import { UsersEdit } from './UsersEdit';
import { UsersList } from './UsersList';
import { UsersShow } from './UsersShow';

export const list = UsersList;
export const edit = UsersEdit;
export const show = UsersShow;

export type { UserRecord } from './User.types';
